import { AgingBracket } from './accountsReceivable.types';

export enum VendorInvoicePaymentStatus {
  PAID = 'PAID',
  UNPAID = 'UNPAID',
}

export type VendorPaymentMode = 'CHECK' | 'ECHECK';

export type VendorInvoiceSortField = 'vendor' | 'amount' | 'date' | 'invoiceNumber';

export interface VendorInvoicesQueryParams {
  vendorIds?: string[];
  invoiceNumbers?: string[];
  checkNumbers?: string[];
  fileNumbers?: string[];
  status?: VendorInvoicePaymentStatus;
  agingBracket?: AgingBracket;
  fromDate?: string;
  toDate?: string;
  sortField?: VendorInvoiceSortField;
  sortDirection?: 'asc' | 'desc';
  pageNo?: number;
  pageSize?: number;
}

export type VendorInvoicesExportCsvParams = Omit<VendorInvoicesQueryParams, 'pageNo' | 'pageSize'>;

export interface VendorInvoiceAging {
  daysOverdue: number;
  bracket?: AgingBracket | null;
}

export interface VendorInvoiceItem {
  processBillingVendorEntryId: string;
  vendorId: string;
  vendorName: string;
  vendorCode?: string | null;
  vendorInvoiceNumber: string;
  workOrderId?: string | null;
  workOrderNumber?: string | null;
  fileNo?: string | null;
  date: string;
  dueDate: string;
  amount: number;
  paymentStatus: VendorInvoicePaymentStatus;
  checkNumber?: string | null;
  isFailedTransaction: boolean;
  paidAt?: string | null;
  aging?: VendorInvoiceAging | null;
}

export interface VendorInvoicesResponse {
  data: VendorInvoiceItem[];
  invoiceNumbers: string[];
  totalAmountDue: string;
  lessThan30DaysDue: string;
  past30DaysDue: string;
  past60DaysDue: string;
  past90DaysDue: string;
  currentWeekDue: string;
  totalRows: number;
  totalPages: number;
  currentPage: number;
}

export interface VendorInvoiceFilterOption {
  value: string;
  label1: string;
  label2: string;
}

export interface VendorInvoiceFilterOptionsResponse {
  vendors: VendorInvoiceFilterOption[];
  invoiceNumbers: VendorInvoiceFilterOption[];
  checkNumbers: VendorInvoiceFilterOption[];
  fileNumbers: VendorInvoiceFilterOption[];
}

export interface ApplyVendorPaymentRequest {
  invoiceIds: string[];
  paymentMode: VendorPaymentMode;
  checkNumber?: string;
  paymentAmount: number;
}

export interface ApplyVendorPaymentResponse {
  vendorPaymentId: string;
  vendorId: string;
  paymentMode: VendorPaymentMode;
  totalAmount: number;
  checkNumber?: string | null;
  paidAt: string;
  invoiceIds: string[];
  message: string;
}

export interface MarkVendorInvoicesFailedRequest {
  invoiceIds: string[];
  isFailedTransaction: boolean;
}

export interface ExportVendorInvoicesRequest {
  invoiceIds: string[];
}

export interface VendorPaymentModeOption {
  label: string;
  value: VendorPaymentMode;
}

export const VENDOR_PAYMENT_MODE_OPTIONS: VendorPaymentModeOption[] = [
  { label: 'Checks', value: 'CHECK' },
  { label: 'E-checks', value: 'ECHECK' },
];
